import { hooks, urlParam, addUrlParam } from "../util";
import $ from "jquery";
import rmlOpts from "rmlopts";
const ID_NONE = -2,
  ID_LAST_QUERIED = -3;
function adjustLinks() {
  let df = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultFolder(false);
  if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */
  }
}

/**
 * Get the default folder and resolve if for example "Last queried folder".
 *
 * @param {boolean} [resolve=true] If false the rmlOpts.others.defaultFolder is returned in raw, so -2 is possible for example
 * @returns {number}
 */
function getDefaultFolder() {
  let resolve = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let id;
  if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */
  }

  // Higher priority list mode query parameter
  id = urlParam("rml_folder") || id;

  // Resolve
  switch (id) {
    case ID_LAST_QUERIED:
      return +rmlOpts.others.lastQueried;
    default:
      return id;
  }
}
if (process.env.PLUGIN_CTX === "pro") {
  /* Silence is golden... Until you have PRO Version! */
}
export { ID_NONE, ID_LAST_QUERIED, getDefaultFolder };